interface CampaignMission {
  idCampaign: string;
  totalMission: number;
}

const totalMissionEnvs = import.meta.env.VITE_TOTAL_MISSION;

export const getTotalMissionsBasedOnEnv = (id: string | number, currentTotal: number) => {
  try {
    if (!id) {
      return currentTotal;
    }
    const missions = JSON.parse(totalMissionEnvs) as CampaignMission[];    
    const currentCampaign = missions.find(
      (campaign) => campaign?.idCampaign?.toString() === id?.toString()
    );

    if (!currentCampaign) {
      return currentTotal;
    }

    return currentCampaign?.totalMission || currentTotal;
  } catch (error) {
    console.error('Error getTotalMissionsBasedOnEnv', error);
    return currentTotal;
  }
}
